/**
 * Style override for the Fluent `Checkbox`.
 */
export const checkboxStyles = theme => ({
    root: {
    //color: theme?.semanticColors?.bodyText,
    },
});
